module.exports = __webpack_public_path__ + "static/media/Beneficiaries.5d2d43c4.svg";